module.exports = __webpack_public_path__ + "img/79.4.NH3-N.d6f31466.png";